import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      id: 1,
      name: 'Facebook',
      url: 'https://facebook.com/smiledental',
      color: '#1877F2',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      id: 3,
      name: 'Twitter',
      url: 'https://twitter.com/smiledental',
      color: '#000000',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417a9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      )
    },
    {
      id: 4,
      name: 'LinkedIn',
      url: 'https://linkedin.com/company/smiledental',
      color: '#0A66C2',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.475-2.236-1.986-2.236-1.081 0-1.722.732-2.004 1.438-.103.249-.129.597-.129.946v5.421h-3.554s.05-8.736 0-9.645h3.554v1.365c.429-.658 1.191-1.595 2.897-1.595 2.117 0 3.704 1.385 3.704 4.362v5.513zM5.337 8.855c-1.144 0-1.915-.762-1.915-1.715 0-.955.77-1.715 1.926-1.715 1.156 0 1.916.76 1.935 1.715 0 .953-.779 1.715-1.935 1.715zm1.946 11.597H3.392V9.807h3.891v10.645zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
        </svg>
      )
    },
    {
      id: 5,
      name: 'YouTube',
      url: 'https://youtube.com/@smiledental',
      color: '#FF0000',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      )
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-content-grid">
            {/* Company Info */}
            <div className="footer-section">
            <div style={{ background:'#019b9b', width:'50%', textAlign:'center', borderRadius:'10px', margin:'0 auto', marginBottom:'10px'}}>
                <img src="/images/bkdental_logo_new.png" alt="Bokundara Dental Surgery Logo" style={{ height: '70px', marginTop: '12px', marginBottom: '6px' }} />
            </div>
                
              
              <p className="footer-description">
                Providing world-class dental care with a personal touch. Your smile is our priority.
              </p>
              <div className="footer-contact" style={{ textAlign:'left'}}>
                <p>📍 Bokundara Dental Surgery, Colombo Road, Bokundara, Piliyandala 10300, Sri Lanka.</p>
                <p>📞 +94 71 468 0485</p>
                <p>✉️ info@bokundaradentalclinic.com</p>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4 className="footer-subtitle">Quick Links</h4>
              <ul className="footer-links">
                <li><a href="/">Home</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/contact">Contact</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer-section">
              <h4 className="footer-subtitle">Connect with Us</h4>
              <ul className="social-media-links" style={{float:'right', margin: '0 auto'}}>
              {socialLinks.map(link => (
                <li key={link.id}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={link.name}
                    className="social-icon"
                    style={{ color: link.color }}
                  >
                    {link.icon}
                  </a>
                </li>
              ))}
            </ul>
            </div>

            {/* Business Hours */}
            {/* <div className="footer-section">
              <h4 className="footer-subtitle">Business Hours</h4>
              <ul className="footer-hours">
                <li>Monday - Friday: 9:00 AM - 6:00 PM</li>
                <li>Saturday: 10:00 AM - 5:00 PM</li>
                <li>Sunday: 11:00 AM - 4:00 PM</li>
                <li>Holidays: Closed</li>
              </ul>
            </div> */}
          </div>

          {/* Social Media Icons */}
          <div className="footer-social-section">
            {/* <h4 className="footer-subtitle">Follow Us</h4> */}
            
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; {currentYear} Bokundara Dental Surgery. All rights reserved. |  Developed By <a href="/privacy">WebArk</a>
            </p>
            
            <div className="footer-bottom-links">
              
              <a href="/privacy">Privacy Policy</a>
              <span className="divider">•</span>
              <a href="/terms">Terms of Service</a>
              <span className="divider">•</span>
              <a href="/sitemap">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
